"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Speaker = void 0;
const Photo_1 = require("./Photo");
const Link_1 = require("./Link");
const common_util_1 = require("../util/common-util");
const EsText_1 = require("./EsText");
const CommonDto_1 = require("../dto/CommonDto");
class Speaker {
    constructor(description) {
        this.id = 0;
        this.eventId = 0;
        this.title = "";
        this.titleShort = "";
        this.subtitle = "";
        this.order = 0;
        this.links = [];
        this.images = [];
        this.imageIds = [];
        this.description = description;
    }
    get initials() {
        return common_util_1.initials(this.title);
    }
    get shortTitleOrTitle() {
        return this.titleShort ? this.titleShort : this.title;
    }
    get hasImages() {
        return this.images.length > 0;
    }
    get mqImageUrl() {
        return this.hasImages ? this.images[0].mq.url : "";
    }
    get lqImageUrl() {
        return this.hasImages ? this.images[0].lq.url : "";
    }
    get tqImageUrl() {
        return this.hasImages ? this.images[0].tq.url : "";
    }
    static fromDto(eventSpeakerDto) {
        const description = EsText_1.EsText.fromOptionalTextDto(eventSpeakerDto.description);
        const speaker = new Speaker(description);
        speaker.id = eventSpeakerDto.id;
        speaker.eventId = eventSpeakerDto.eventId;
        speaker.title = eventSpeakerDto.title;
        if (eventSpeakerDto.titleShort) {
            speaker.titleShort = eventSpeakerDto.titleShort;
        }
        if (eventSpeakerDto.subtitle) {
            speaker.subtitle = eventSpeakerDto.subtitle;
        }
        speaker.order = eventSpeakerDto.order;
        if (eventSpeakerDto.links && eventSpeakerDto.links.length > 0) {
            speaker.links = eventSpeakerDto.links.map(linkDto => Link_1.Link.fromDto(linkDto));
        }
        if (eventSpeakerDto.images && eventSpeakerDto.images.length > 0) {
            eventSpeakerDto.images.forEach(photoDto => {
                switch (photoDto.type) {
                    case CommonDto_1.PhotoType.PHOTO:
                        const photo = Photo_1.Photo.fromDto(photoDto);
                        speaker.images.push(photo);
                        speaker.imageIds.push(photo.uploadId);
                        break;
                    case CommonDto_1.PhotoType.ID:
                        const photoId = photoDto;
                        speaker.imageIds.push(photoId.uploadId);
                        break;
                }
            });
        }
        return speaker;
    }
    toDto() {
        const resultDto = {
            id: this.id,
            eventId: this.eventId,
            title: this.title,
            order: this.order
        };
        if (this.titleShort) {
            resultDto.titleShort = this.titleShort;
        }
        if (this.subtitle) {
            resultDto.subtitle = this.subtitle;
        }
        if (this.description.notEmpty) {
            resultDto.description = this.description.toOptionalTextDto();
        }
        if (!common_util_1.isEmptyArray(this.imageIds)) {
            const photoIdsDto = this.imageIds.map(value => {
                const photoIdDto = { type: CommonDto_1.PhotoType.ID, uploadId: value };
                return photoIdDto;
            });
            resultDto.images = photoIdsDto;
        }
        if (!common_util_1.isEmptyArray(this.links)) {
            resultDto.links = [...this.links.map(link => link.toDto())];
        }
        return resultDto;
    }
}
exports.Speaker = Speaker;
